import React, { useEffect } from 'react'
import { Select } from 'antd'

import { useStore } from '@/store'
import { observer } from 'mobx-react-lite'
import { runInAction, set, toJS } from 'mobx'


const City = () => {

    const { RegisterStore } = useStore()

    //获得table数据
    useEffect(() => {
        RegisterStore.provinceLinkage()
        // eslint-disable-next-line
    }, [])
    //五级联动
    const province = async (value) => {
        runInAction(() => {
            set(RegisterStore, { provinceCode: value })
            set(RegisterStore, { key01: Math.random() })
            set(RegisterStore, { key02: Math.random() })
            set(RegisterStore, { key03: Math.random() })
            set(RegisterStore, { key04: Math.random() })
        })
        await RegisterStore.cityLinkage(value)
    }
    const city = async (value) => {
        runInAction(() => {
            set(RegisterStore, { cityCode: value })
            set(RegisterStore, { key02: Math.random() })
            set(RegisterStore, { key03: Math.random() })
            set(RegisterStore, { key04: Math.random() })
        })
        await RegisterStore.countyLinkage(value)

    }
    const county = async (value) => {
        runInAction(() => {
            set(RegisterStore, { countyCode: value })
            set(RegisterStore, { key03: Math.random() })
            set(RegisterStore, { key04: Math.random() })
        })
        await RegisterStore.townshipLinkage(value)

    }
    const township = async (value) => {
        runInAction(() => {
            set(RegisterStore, { townshipCode: value })
            set(RegisterStore, { key04: Math.random() })
        })
        await RegisterStore.villageLinkage(value)

    }
    const village = async (value) => {
        runInAction(() => {
            set(RegisterStore, { villageCode: value })
        })
    }

    return (
        <>
            <Select
                placeholder='省'
                onChange={province}
                options={toJS(RegisterStore.province)}
                style={{ width: '90px', marginRight: '6px' }}

            />
            <Select
                placeholder='市'
                onChange={city}
                style={{ width: '90px', marginRight: '6px' }}
                options={toJS(RegisterStore.city)}
                key={RegisterStore.key01}
            />
            <Select
                placeholder='县'
                onChange={county}
                style={{ width: '90px', marginRight: '6px' }}
                options={toJS(RegisterStore.county)}
                key={RegisterStore.key02}
            />
            <Select
                placeholder='乡'
                onChange={township}
                options={toJS(RegisterStore.township)}
                style={{ width: '90px', marginRight: '6px' }}
                key={RegisterStore.key03}
            />
            <Select
                placeholder='村'
                onChange={village}
                options={toJS(RegisterStore.village)}
                style={{ width: '90px' }}
                key={RegisterStore.key04}
            />
        </>
    )
}

export default observer(City)  